
<template>
  <div
    :class="['action-container', expandedClass, mobileClass]"
    @mouseover="mouseEntered()"
    @mouseleave="mouseLeft()"
    @click="tapped()"
  >
    <div class="action">
      <div class="action-svg" @click="toggleSoundscape">
        <svg
          v-if="shape == 'email'"
          width="36"
          height="27"
          viewBox="0 0 36 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M34 13V19.6667C34 22.6122 31.6122 25 28.6667 25H7.33333C4.38782 25 2 22.6122 2 19.6667V13M7.33333 24H28.6667C31.6122 24 34 21.6122 34 18.6667V7.33333C34 4.38781 31.6122 2 28.6667 2H7.33333C4.38781 2 2 4.38781 2 7.33333V18.6667C2 21.6122 4.38782 24 7.33333 24Z"
              stroke="#807D79"
              class="colorable-stroke"
              stroke-width="1.81567"
            />
          </g>
          <g>
            <path
              d="M3 4.04225L12.071 13.1133M32.9443 3.5L23.3303 13.1133M23.3303 13.1133L21.8909 14.5526C19.5767 16.8669 15.8246 16.8669 13.5104 14.5527L12.071 13.1133M23.3303 13.1133L32.9443 22.7273M12.071 13.1133L3 22.1843"
              stroke="#807D79"
              class="colorable-stroke"
              stroke-width="1.81567"
            />
          </g>
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 1 28 24"
          fill="none"
          class="nudge-right"
          v-if="shape == 'sound'"
        >
          <g id="icon-tunes">
            <g id="sound-note">
              <path
                d="M8.26266 20.3671C8.26266 22.3726 6.63686 23.9984 4.63133 23.9984C2.6258 23.9984 1 22.3726 1 20.3671C1 18.3616 2.6258 16.7358 4.63133 16.7358C6.63686 16.7358 8.26266 18.3616 8.26266 20.3671Z"
                fill="#807D79"
                class="colorable-fill"
              />
              <path
                d="M22.1828 17.9462C22.1828 19.9517 20.557 21.5775 18.5514 21.5775C16.5459 21.5775 14.9201 19.9517 14.9201 17.9462C14.9201 15.9407 16.5459 14.3149 18.5514 14.3149C20.557 14.3149 22.1828 15.9407 22.1828 17.9462Z"
                fill="#807D79"
                class="colorable-fill"
              />
              <path
                d="M22.1828 2.43913C22.1828 1.68769 21.5053 1.11783 20.7649 1.24658L9.26571 3.24645C8.68592 3.34728 8.26266 3.8505 8.26266 4.43899V5.84178L22.1828 3.42089V2.43913Z"
                fill="#807D79"
                class="colorable-fill"
              />
              <path
                d="M8.26266 20.3671C8.26266 22.3726 6.63686 23.9984 4.63133 23.9984C2.6258 23.9984 1 22.3726 1 20.3671C1 18.3616 2.6258 16.7358 4.63133 16.7358C6.63686 16.7358 8.26266 18.3616 8.26266 20.3671ZM8.26266 20.3671V5.84178M22.1828 17.9462C22.1828 19.9517 20.557 21.5775 18.5514 21.5775C16.5459 21.5775 14.9201 19.9517 14.9201 17.9462C14.9201 15.9407 16.5459 14.3149 18.5514 14.3149C20.557 14.3149 22.1828 15.9407 22.1828 17.9462ZM22.1828 17.9462V3.42089M22.1828 3.42089V2.43913C22.1828 1.68769 21.5053 1.11783 20.7649 1.24658L9.26571 3.24645C8.68592 3.34728 8.26266 3.8505 8.26266 4.43899V5.84178M22.1828 3.42089L8.26266 5.84178"
                stroke="#807D79"
                class="colorable-stroke"
                stroke-width="1.81567"
              />
            </g>
            <g id="cross-bar" v-if="soundscapeLabel == 'OFF'">
              <path
                id="Vector 3049"
                d="M2.51953 6.70703L26.4662 24.2728"
                stroke="#FEF9F1"
                stroke-width="3"
              />
              <path
                id="Vector 3048"
                d="M2.21875 4.73047L26.1654 22.2963"
                stroke="#807D79"
                class="colorable-stroke"
                stroke-width="1.81567"
              />
            </g>
          </g>
        </svg>
        <!-- [{{ soundscapeLabel }}] Soundscape -->
      </div>
      <!-- <button @click="toggleEffects">[{{ effectsLabel }}] Effects</button> -->
      <div class="action-label">
        <p>
          {{ title
          }}<span v-if="subtitle" class="faded"><br />{{ subtitle }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Action",
  data() {
    return {
      expanded: false,
      // mobileBreakpoint: 480,
    };
  },
  props: ["shape", "title", "subtitle", "soundscapeLabel"],
  computed: {
    expandedClass() {
      if (this.expanded == true) {
        return "action--is-expanded";
      } else {
        return "";
      }
    },
    // isMobile() {
    //   return window.innerWidth <= this.mobileBreakpoint ? true : false;
    // },
    // mobileClass() {
    //   return window.innerWidth <= this.mobileBreakpoint
    //     ? "action-is--mobile"
    //     : "";
    // },
  },
  methods: {
    tapped() {
      // if (!this.isMobile) {
      //   return;
      // }

      // if (this.isMobile && !this.expanded) {
      //   console.log("setting expanded to true");
      //   this.expanded = true;
      // }

      this.$emit("make-action");
    },
    mouseLeft() {
      this.expanded = false;
    },
    mouseEntered() {
      if (this.isMobile) {
        return;
      }

      this.expanded = true;
    },
  },
  mounted() {},
};
</script>

<style>
.action-container {
  filter: drop-shadow(0px 4.38857px 14.2629px rgba(114, 74, 13, 0.25));
  padding: 8px;
  border-radius: 200px;
  cursor: pointer;
  transform-origin: 26px center;
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
}

.action-container:active {
  transform: scale(0.8);
}

.action {
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-gap: 1.2rem;
}

.action .action-svg {
  filter: blur(0.06rem);
  display: flex;
  justify-content: center;
  transform: scale(1);
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
}

.action .action-label {
  display: block;
  opacity: 0;
  pointer-events: none;
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
  transform: translateX(-0.8rem);
}

.action .action-label p {
  margin: 0;
  font-size: 1.6rem;
  line-height: 120%;
}

.action .action-label p .faded {
  font-size: 1.4rem;
  color: #919191;
}

.action-container.action--is-expanded .action .action-label {
  opacity: 1;
  pointer-events: all;
  transform: translateX(0);
}

.action-container .action .action-svg .colorable-fill,
.action-container .action .action-svg .colorable-stroke {
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
}

.action-container.action--is-expanded .action .action-svg .colorable-fill {
  fill: var(--black);
}

.action-container.action--is-expanded .action .action-svg .colorable-stroke {
  stroke: var(--black);
}

.nudge-right {
  margin-left: 5.5px;
}

@media (max-width: 560px) {
  .action-label {
    display: none;
  }
}
</style>
